import React, { FC, useCallback, useState } from 'react'
import { Popover } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { HelpTable } from './HelpTable'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiPaper-elevation8': {
      padding: '30px 60px',
      minWidth: 700,
      height: 430,
      boxShadow: 'none',
      backgroundColor: '#f6f5fe',
    },
  },
  container: {
    color: theme.palette.primary.dark,
    opacity: 0.6,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    },
  },
  activeIcon: {
    opacity: 1,
    color: theme.palette.info.main,
  },
}))

export const HelpMatrixPopover: FC = () => {
  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <span
        className={
          !anchorEl
            ? clsx('material-icons', classes.container)
            : clsx('material-icons', classes.container, classes.activeIcon)
        }
        onClick={handleClick}
      >
        help_outline
      </span>

      <Popover
        className={classes.root}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <HelpTable />
      </Popover>
    </>
  )
}
